import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import R from 'ramda';
import axios from 'axios';
import { userLogout } from 'actions/loginForms';
import { store } from '../../index';
import { initAxios } from 'utils';
import { loadProfile } from 'actions/profile';

const mapStateToProps = ({ profile }) => ({
  profile
});

const mapDispatchToProps = {
  loadProfile
};

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class ObserveErrors extends Component {
  render() {
    axios.interceptors.response.use(null, (error) => {
      if (R.path(['response', 'data', 'error', 'error-code'], error) === 'USER_HAS_NO_PAID_SERVICE') {
        this.props.history.push('/');
        if (this.props.profile.tariff && !this.props.profile.isLoading) {
          this.props.loadProfile()
          .then(() => {
            this.props.history.push('/');
          });
        }
      }
      if (R.path(['response', 'data', 'error', 'error-code'], error) === 'USER_HAS_NOT_PERMISSION') {
        // WTF ?
        store.getState().authentication.authenticated = false;
        store.getState().loginForms.isLoading = false;
        store.getState().loginForms.loginState = 'Number';
        localStorage.removeItem('token');
        initAxios();
        store.dispatch(userLogout());
      }
      return Promise.reject(error);
    });

    return (
      null
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ObserveErrors/ObserveErrors.js